import { loadStripe, Stripe } from '@stripe/stripe-js';

const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const stripePromise: Promise<Stripe | null> = key ? loadStripe(key) : Promise.resolve(null);
